import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import LocationSection from './components/LocationSection';
import ServicesSection from '../../home/components/ServicesSection';
import BenefitsSection from '../../home/components/BenefitsSection';
import TintShadesSection from '../../home/components/TintShadesSection';
import TestimonialsSection from '../../home/components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from '../../home/components/CTASection';
import { useSEO, generateLocalBusinessSchema, generateWebPageSchema } from '../../../utils/seo';
import { useEffect } from 'react';

export default function BaltimorePage() {
  // Apply localized SEO metadata with geo-tags
  useSEO({
    title: 'Baltimore Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint',
    description:
      'Professional window tinting services in Baltimore, Maryland. Expert ceramic tint installation, mobile service, commercial tinting, vehicle decals, and headlight tinting. Serving Baltimore City, Inner Harbor, Federal Hill, Canton, Fells Point. Lifetime warranty. Call (443) 800-0348.',
    keywords:
      'window tinting Baltimore, ceramic tint Baltimore MD, mobile tinting Baltimore, commercial tinting Baltimore, vehicle decals Baltimore',
    canonical: '/locations/baltimore',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          ...generateLocalBusinessSchema(),
          '@type': 'AutoRepair',
          name: 'U.B.K Window Tint - Baltimore',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '',
            addressLocality: 'Baltimore',
            addressRegion: 'MD',
            postalCode: '21201',
            addressCountry: 'US',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: '39.2904',
            longitude: '-76.6122',
          },
          areaServed: {
            '@type': 'City',
            name: 'Baltimore',
            '@id': 'https://en.wikipedia.org/wiki/Baltimore',
          },
        },
        generateWebPageSchema(
          'Baltimore Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint',
          'Professional window tinting services in Baltimore, Maryland. Serving Baltimore City with lifetime warranty and same-day service.',
          '/locations/baltimore'
        ),
      ],
    },
  });

  useEffect(() => {
    // Add geo meta tags for local SEO
    const geoTags = [
      { name: 'geo.region', content: 'US-MD' },
      { name: 'geo.placename', content: 'Baltimore' },
      { name: 'geo.position', content: '39.2904;-76.6122' },
      { name: 'ICBM', content: '39.2904, -76.6122' },
    ];

    geoTags.forEach(tag => {
      let meta = document.querySelector(`meta[name="${tag.name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <header>
        <h1 className="sr-only">
          Baltimore Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint
        </h1>
      </header>
      <main>
        <HeroSection />
        <LocationSection />
        <ServicesSection />
        <BenefitsSection />
        <TintShadesSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
